import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Heading, Link, Panel } from '@printdeal/ui-library';
import { StoreToggle } from '@printdeal/feature-management/react';
import { Link as GatsbyLink } from 'gatsby';
import { messages as generalMessages } from '../../translations/general';
// @ts-expect-error
import { selectors as customerSelectors } from '../../../../store/slices/customerSlice';
import Breadcrumb from '../../../Breadcrumb';
import Head from '../../../PrivateHead';
import useHubspotForm from '../../../hubspot/useHubspotForm';
import HubspotForm from '../../../hubspot/HubspotForm';

const NewsletterPage = () => {
  const intl = useIntl();
  const hubspotEmailPreferences = useHubspotForm('emailPreferences');
  const hubspotNewsLetterPreferences = useHubspotForm('newsletterPreferences');
  const hubspotNewsletterRegistration = useHubspotForm('newsletterRegistration');
  const isNewsletterOptIn = useSelector((state: any) => customerSelectors.isNewsletterOptIn(state));

  return (
    <div className="data-sentry-block pd-mb-7 pd-grid pd-gap-7">
      <Head title={intl.formatMessage(generalMessages.newsletterPageTitle)} />

      <Breadcrumb>
        <Breadcrumb.Item to="..">
          <FormattedMessage id="account.index.title" defaultMessage="My account" />
        </Breadcrumb.Item>
        <Breadcrumb.Item isCurrentPage>
          <FormattedMessage id="account.newsletter" defaultMessage="E-mail preferences" />
        </Breadcrumb.Item>
      </Breadcrumb>

      <Heading as="h1">
        <FormattedMessage id="account.newsletter" defaultMessage="E-mail preferences" />
      </Heading>

      <Panel>
        <Panel.Header title={<FormattedMessage id="account.newsletter.reminders" defaultMessage="Reminders" />} />
        <HubspotForm formId={hubspotEmailPreferences.hubspotForm} />
      </Panel>
      <StoreToggle id="drukwerkdeal-nl_printdeal-be">
        <StoreToggle.Enabled>
          <Panel>
            <Panel.Header title={<FormattedMessage id="account.newsletter.newsletters" defaultMessage="Newsletters" />} />
            {isNewsletterOptIn ? (
              <HubspotForm formId={hubspotNewsLetterPreferences.hubspotForm} />
            ) : (
              <HubspotForm formId={hubspotNewsletterRegistration.hubspotForm} />
            )}
          </Panel>
        </StoreToggle.Enabled>
      </StoreToggle>

      <Link as={GatsbyLink} to="../" iconBefore="chevron-left" variant="secondary">
        <FormattedMessage id="account.linkToAccount" defaultMessage="Link to account" />
      </Link>
    </div>
  );
};

export default NewsletterPage;
